import * as Types from '../../../api';

import { gql } from '@apollo/client';
export type DomainE164RangesFragment = { __typename?: 'Domain', endpointE164RangesForAdmins?: string | null };

export const DomainE164RangesFragmentDoc = gql`
    fragment DomainE164Ranges on Domain {
  endpointE164RangesForAdmins
}
    `;